<template>
  <header v-if="!route.meta?.category">
    <div id="logo">
      <a href="/"><img src="../../assets/images/logo.svg" alt="Flightfox" /></a>
    </div>
    <div v-if="route.name" class="button-group">
      <router-link :to="{ name: 'trips' }" class="button sub">Dashboard</router-link>
      <router-link :to="{ name: 'trip_new' }" class="button">Book a Trip or Group</router-link>
    </div>
  </header>
</template>

<script setup>
import { useRoute } from "vue-router";
const route = useRoute();
</script>
